import React from 'react';
import { Card, Statistic } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined, MinusOutlined } from '@ant-design/icons';
import './StatsSummaryCard.scss';

const StatsSummaryCard = ({ 
  title, 
  currentValue = 0, 
  previousValue = 0, 
  loading = false,
  formatter = (val) => val.toLocaleString('pt-BR'),
  prefix = '',
  suffix = ''
}) => {
  const variation = previousValue > 0 
    ? ((currentValue - previousValue) / previousValue * 100)
    : currentValue > 0 ? 100 : 0;

  const getVariationColor = () => {
    if (variation > 0) return '#52c41a';
    if (variation < 0) return '#ff4d4f';
    return '#8c8c8c';
  };

  const getVariationIcon = () => {
    if (variation > 0) return <ArrowUpOutlined />;
    if (variation < 0) return <ArrowDownOutlined />;
    return <MinusOutlined />;
  };

  return (
    <Card 
      className="stats-summary-card"
      loading={loading}
      size="small"
    >
      <Statistic
        title={title}
        value={formatter(currentValue)}
        prefix={prefix}
        suffix={suffix}
        valueStyle={{ 
          color: '#1890ff',
          fontSize: '24px',
          fontWeight: 'bold'
        }}
      />
      <div className="variation-indicator" style={{ color: getVariationColor() }}>
        {getVariationIcon()} {Math.abs(variation).toFixed(2)}% vs período anterior
      </div>
      <div className="previous-value">
        Período anterior: {prefix}{formatter(previousValue)}{suffix}
      </div>
    </Card>
  );
};

export default StatsSummaryCard;
